import { Minus, ShieldAlert } from 'lucide-react';
import { FC } from 'react';
import priorityHighImg from '@/assets/priority-high.png';
import priorityMediumImg from '@/assets/priority-medium.png';
import priorityLowImg from '@/assets/priority-low.png';

const PriorityBarIcon: FC<{ src: string; className?: string }> = ({
  src,
  className = 'h-4 w-4',
}) => <img src={src} alt="" className={className} />;

export const PRIORITY_ICONS: Record<string, FC<{ className?: string }>> = {
  urgent: ShieldAlert,
  high: ({ className }) => (
    <PriorityBarIcon src={priorityHighImg} className={className} />
  ),
  medium: ({ className }) => (
    <PriorityBarIcon src={priorityMediumImg} className={className} />
  ),
  low: ({ className }) => (
    <PriorityBarIcon src={priorityLowImg} className={className} />
  ),
  none: Minus,
};

export const PriorityIcon: FC<{
  priority: string | null;
  className?: string;
}> = ({ priority, className = 'h-4 w-4' }) => {
  if (!priority) return null;
  const Icon = PRIORITY_ICONS[priority];
  if (!Icon) return null;
  return <Icon className={className} />;
};
